// components/CustomButton.tsx
import React from 'react';
import { Typography, SxProps } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

type Typographies = 'heading1' | 'body1' | 'body2' | 'italic' | 'heading2' | 'heading3' | 'caption';

type CustomButtonProps = {
  type?: Typographies;
  sx?: SxProps;
  textAlign?: CanvasTextAlign;
  children: React.ReactNode;
  component?: any;
  flex?: number;
  padding?: string;
  margin?: string;
  color?: string;
  gutterBottom?: boolean;
};

const typographies: Record<
  Typographies,
  {
    fontSize?: string;
    fontWeight?: string;
    variant?: Variant;
    fontStyle?: string;
  }
> = {
  heading1: {
    fontSize: '40px',
    fontWeight: 'bold',
  },
  body1: {
    variant: 'body1',
  },
  body2: {
    variant: 'body1',
    fontWeight: 'bold',
  },
  italic: {
    fontStyle: 'italic',
  },
  heading2: {
    variant: 'h4',
  },
  heading3: {
    variant: 'h5',
  },
  caption: {
    variant: 'caption',
    fontWeight: 'bold',
    fontSize: '14px',
  },
};

export const ThemeTypography: React.FC<CustomButtonProps> = ({
  type = 'body1',
  sx,
  color,
  children,
  flex,
  textAlign,
  gutterBottom,
  padding,
  component,
  margin,
}) => {
  const { fontSize, fontWeight, variant, fontStyle } = typographies[type];

  return (
    <Typography
      sx={sx}
      flex={flex}
      textAlign={textAlign}
      fontSize={fontSize}
      fontWeight={fontWeight}
      gutterBottom={gutterBottom}
      color={color}
      variant={variant}
      component={component}
      padding={padding}
      margin={margin}
      fontStyle={fontStyle}
    >
      {children}
    </Typography>
  );
};
